import { IEvent } from '../events';

export interface FeedbackForm {
  id: number;
  eventId: number;
  title?: string;
  description?: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
  questions: FeedbackQuestion[];
  event?: Pick<IEvent, 'cover' | 'title'>;
}

export enum QuestionType {
  TEXT = 'TEXT',
  NPS = 'NPS',
  RATING = 'RATING',
}

export interface FeedbackAnswer {
  id: number;
}

export interface FeedbackResponse {
  id: number;
  eventId: number;
  formId: number;
  email?: number;
  phone?: number;
  answers?: FeedbackAnswer[];
  form?: FeedbackForm;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
  answersCount: number;
}
export interface FeedbackQuestion {
  id: number;
  questionText: string;
  questionType: QuestionType;
  isRequired: boolean;
  order: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface CreateAnswerDTO {
  questionId: number;
  numericValue?: number;
  textValue?: string;
  booleanValue?: boolean;
}

export interface SubmitFeedbackDTO {
  slug: string;
  userId?: number;
  formId?: number;
  answers: CreateAnswerDTO[];
}

export interface AnswersState {
  [questionId: number]: string | number;
}
